import { forwardRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@/lib/utils";

type IconButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: "default" | "active";
  size?: "sm" | "md" | "lg";
  asChild?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

type IconButtonElement = HTMLButtonElement | HTMLAnchorElement;

const IconButton = forwardRef<IconButtonElement, IconButtonProps>(
  (
    {
      children,
      className,
      variant = "default",
      size = "md",
      asChild = false,
      ...props
    },
    ref,
  ) => {
    const baseClasses = cn(
      "btn-icon",
      size === "sm" && "btn-icon-sm",
      size === "md" && "btn-icon-md",
      size === "lg" && "btn-icon-lg",
      variant === "default" && "btn-icon-default",
      variant === "active" && "btn-icon-active",
      className,
    );
    const Comp = (asChild ? Slot : "button") as React.ElementType;
    return (
      <Comp
        ref={ref as React.Ref<IconButtonElement>}
        className={baseClasses}
        {...props}
      >
        {children}
      </Comp>
    );
  },
);

IconButton.displayName = "IconButton";

export { IconButton };
